import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.eventTrackingUrl}v1`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken.replace('BEARER', 'Bearer')
    }
  })

const eventTrackingApi = {
  getTrackingUrls: (pageId, params) => instance().get(`/tracking-url/cms/${pageId}`, { params })
}

export default eventTrackingApi



// WEBPACK FOOTER //
// ./src/api/event-tracking.js